module.exports = __webpack_public_path__ + "static/media/wave-back.6c3dea4a.svg";